import { useEffect, useState } from 'react';
import { onValue, ref } from 'firebase/database';
import { db } from '@/shared/firebase/config';

export type CenterConfig = {
  name?: string;
  address?: string;
  phone?: string;
};

export function useCenterConfig(centerId: string | null): CenterConfig | null {
  const [cfg, setCfg] = useState<CenterConfig | null>(null);
  useEffect(() => {
    if (!centerId) { setCfg(null); return; }
    return onValue(ref(db, `centers/${centerId}/config`), (snap) => {
      setCfg((snap.val() as CenterConfig) || null);
    });
  }, [centerId]);
  return cfg;
}
